import { DefaultContainedButton } from '@/components/buttons';
import { FormsSelector } from '@/store/forms';
import { ArrowForwardRounded } from '@mui/icons-material';
import { Card, Stack, Typography } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
export const CompleteLogin = () => {
    const formId = 'userForm';
    const formValues = useSelector((state) => FormsSelector.getFormValues(state, formId));
    const { email = '' } = formValues;
    return (React.createElement(Card, { sx: {
            p: 3,
            background: 'white',
            borderRadius: '16px',
            border: (theme) => `1px solid${theme.palette.grey[200]}`,
        } },
        React.createElement(Typography, { mb: 1, color: "secondary", fontSize: "1rem", fontWeight: 600 }, "Complete your login"),
        React.createElement(Stack, { mb: 2, direction: "row", alignItems: "center", gap: 0.2, flexWrap: "wrap" },
            React.createElement(Typography, { color: "secondary", fontSize: "0.875rem", fontWeight: 500 }, "We've sent a temporary password to"),
            React.createElement(Typography, { color: "primary", fontSize: "0.875rem", fontWeight: 500 }, email)),
        React.createElement(DefaultContainedButton, { fullWidth: true, title: "Continue to login", endIcon: React.createElement(ArrowForwardRounded, null) })));
};
